import * as types from './types'
import {
  ServicingFeeAmountsResponse,
  ServicingFeedQuery,
  ServicingFeedResponse,
} from './types'

/**
 * The feed, with the generation the request started under: the reducer drops
 * it if a write has bumped the generation since (utils/generation.ts).
 */
export const getServicing = (
  response: ServicingFeedResponse,
  query: ServicingFeedQuery,
  generation?: number,
  readId?: number,
) => ({
  type: types.GET_SERVICING,
  payload: { response, query, generation, readId },
})

/** The window the page wants now — recorded on every call, even one that joins a read in flight. */
export const servicingWindowRequested = (query: ServicingFeedQuery) => ({
  type: types.SERVICING_WINDOW_REQUESTED,
  payload: query,
})

/** One read started (once per request, however many attempts it takes). */
export const startLoadingServicing = () => ({
  type: types.START_LOADING_SERVICING,
  payload: null,
})

export const stopLoadingServicing = () => ({
  type: types.STOP_LOADING_SERVICING,
  payload: null,
})

/** A write happened that the rows cannot be patched for. The page reloads once. */
export const invalidateServicing = () => ({
  type: types.INVALIDATE_SERVICING,
  payload: null,
})

/**
 * The read failed. Carries its window and the generation it started under:
 * the reducer ignores a failure for a window the page no longer wants, and
 * keeps `stale` when a write landed meanwhile (that reload is still owed);
 * otherwise it clears `stale` so nothing retries for ever.
 */
export const servicingLoadFailed = (
  message: string,
  query: ServicingFeedQuery,
  generation?: number,
) => ({
  type: types.SERVICING_LOAD_FAILED,
  payload: { message, query, generation },
})

export const setServicingFeeAmounts = (
  response: ServicingFeeAmountsResponse,
  readId: number,
) => ({
  type: types.SET_SERVICING_FEE_AMOUNTS,
  payload: { response, readId },
})

export const servicingFeeAmountsFailed = (message: string, readId: number) => ({
  type: types.SERVICING_FEE_AMOUNTS_FAILED,
  payload: { message, readId },
})
